import { render, staticRenderFns } from "./ShareToWhatsapp.vue?vue&type=template&id=6dbc90e6&"
import script from "./ShareToWhatsapp.vue?vue&type=script&lang=js&"
export * from "./ShareToWhatsapp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports